export const radius = {
  none: "0px",
  sm: "8px",
  md: "16px",
  lg: "24px",
  pill: "500px",
};

export const width = {
  none: "0px",
  hairline: "1px",
  thin: "2px",
  thick: "4px",
  heavy: "8px",
};

export type RadiusKeys = keyof typeof radius;
export type Radius = typeof radius;

export type WidthKeys = keyof typeof width;
export type Width = typeof width;
